import { Component, OnInit, ViewChild } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { Table } from 'primeng/table';
import { Router } from '@angular/router';
import { PurchaseorderService } from '../../../../services/purchaseorder.service';
import { PurchaseOrder, PurchaseOrderGridResponse, RecentInteractions, UpdateInventory, gridPageRequest, gridPagination } from '../../../../model/common/common.model';
import _ from 'lodash';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ReportLookupComponent } from '../../../Reports/report-lookup/report-lookup.component';
import { catchError, map, switchMap } from 'rxjs/operators';
import { EmailTemplateService } from '../../../../services/email-template.service';
import { CustomerService } from '../../../../services/customer.service';
import { SalesService } from '../../../../services/sales.service';
import { InventoryService } from '../../../../services/inventory.service';
import { ReportCenterService } from '../../../../services/report-center.service';
import { AdministratorService } from '../../../../services/administrator.service';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-list-purchaseorder',
  standalone: true,
  imports: [SharedModule, CommonModule],
  templateUrl: './list-purchaseorder.component.html',
  styleUrls: ['./list-purchaseorder.component.scss']
})
export class ListPurchaseorderComponent implements OnInit {
  @ViewChild('dt1') dt1: Table | undefined;

  selectedPOrder: PurchaseOrder[] = [];
  searchKey: string | undefined;
  paginator: boolean | undefined;
  Data: any;
  hide: boolean = false;
  companyInfo: any = {};
  ReportPath: any;
  unitLabel: string = '';
  purchaseOrderNumber: any;

  constructor(
    private route: Router,
    private porderservice: PurchaseorderService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    public dialogService: DialogService,
    public ref: DynamicDialogRef,
    private emailTemplateService: EmailTemplateService,
    private customerService: CustomerService,
    private salesService: SalesService,
    private inventoryService: InventoryService,
    private reportService: ReportCenterService,
    private administratorService: AdministratorService,
  ) { }

  loader: boolean = false;

  result: PurchaseOrderGridResponse = {
    purchaseOrder: [],
    totalRecords: 0
  };
  gridPagination: gridPagination = {
    first: 0,
    last: 0,
    totalRecords: 10
  };
  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 20,
    id: 0
  };
  projectBoMNameCache: { [key: string]: string } = {};

  ngOnInit(): void {
    document.title = 'Purchase Order List';
    this.getPurchaOrder(this.pageRequest);
    this.getSystemConfigsData();
    this.getCompanyDetails();
    this.searchEffect();
    this.inventoryService.getUnitByAppKey('unitNameLabel')
      .subscribe((res: any) => {
        this.unitLabel = res?.data || 'Unit';
      });
  }


  getPurchaOrder(data: gridPageRequest): void {
    // this.loader = true;
    this.porderservice.getPurchaseOrder(data).subscribe({
      next: (data: any) => {
        this.result = data as PurchaseOrderGridResponse;
        // this.loader = false;
      },
      error: (error) => {
        console.log(error);
        // this.loader = false;
      }
    });
  }

  deletePOrder(): void {
    this.confirmationService.confirm({
      header: 'Are you sure?',
      message: 'Please confirm to proceed.',
      accept: () => {
        if (!this.selectedPOrder || this.selectedPOrder.length === 0) {
          return;
        }

        const selectedOrdersWithValidStatus = this.selectedPOrder.filter((order: any) =>
          ['Ready', 'Pending Approval', 'Pending Level 1 Approval'].includes(order.purchaseOrder_Status)
        );

        if (selectedOrdersWithValidStatus.length === 0) {
          this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'No valid orders to delete.' });
          return;
        }

        const updateAllInventories = async () => {
          for (const order of selectedOrdersWithValidStatus) {
            try {
              const lineItems: any[] = await this.porderservice.getPurchaseOrderLineitemById(order.purchaseOrderNumber)
                .pipe(catchError((err) => {
                  console.error('Error fetching line items for order:', order.purchaseOrderNumber, err);
                  return of([]);
                }))
                .toPromise();

              for (const lineItem of lineItems) {
                await new Promise<void>((resolve) => {
                  this.updateInventory(lineItem, order.warehouseId, order.purchaseOrderNumber, resolve);
                });
              }
            } catch (err) {
              console.error('Error in inventory update loop:', err);
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed during inventory updates.' });
              throw err;
            }
          }
        };

        updateAllInventories().then(() => {
          const purchaseOrderIdsToDelete = selectedOrdersWithValidStatus.map(order => order.purchaseOrderId);
          this.porderservice.deletePurchaseOrder(purchaseOrderIdsToDelete).subscribe({
            next: () => {
              this.selectedPOrder = [];
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted successfully.' });
              this.getPurchaOrder(this.pageRequest);
            },
            error: (err: any) => {
              console.error('Error deleting purchase orders:', err);
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to delete purchase orders.' });
            }
          });
        }).catch(err => {
          console.error('Error during inventory update:', err);
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to update inventory before deletion.' });
        });
      },
      reject: () => {
        this.messageService.add({ severity: 'info', summary: 'Cancelled', detail: 'Delete action was cancelled.' });
      }
    });
  }

  updateInventory(lineItemData: any, warehouseId: number, purchaseOrderNumber: any, callback: () => void): void {
    this.loader = true;

    const Inventory: UpdateInventory = {
      productId: lineItemData.productId,
      warehouseId: warehouseId,
      productCode: lineItemData.productCode,
      status: "DeletePO",
      transactionType: "",
      transactionNo: purchaseOrderNumber,
      quantity: lineItemData.poQuantity,
      createdBy: localStorage.getItem('username') || '',
      transactionDate: new Date(),
      createdDate: new Date(),
    };

    this.inventoryService.updateInventory(Inventory).subscribe({
      next: () => {
        this.loader = false;
        callback();
      },
      error: (error) => {
        console.error(error);
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Error occurred while updating inventory.' });
        this.loader = false;
        callback();
      }
    });
  }


  editPOrder(data?: any): void {
    if (data) {
      this.route.navigate(['/home/createPurchaseOrder'], { queryParams: { 'purchaseOrderId': data }, skipLocationChange: false });
    } else {
      this.route.navigate(['/home/createPurchaseOrder'], { queryParams: { 'purchaseOrderId': this.selectedPOrder[0].purchaseOrderId }, skipLocationChange: false });
    }
  }

  CreatePOrder(): void {
    this.route.navigate(['home/createPurchaseOrder']);
  }

  loadPOrder(event: any): void {
    if (this.searchKey && this.searchKey.trim() !== '') {
      this.searchPO();
    } else {
      this.pageRequest.pageSize = this.pageRequest.pageSize + event.first + 5;
      this.getPurchaOrder(this.pageRequest);
    }
  }

  showReport(value: any): void {
    const formCode = 'PurchaseOrder';

    this.reportService.getReportName(formCode).subscribe({
      next: (report: any) => {
        const purchaseOrderNumber = value.purchaseOrderNumber;
        const sanitizedOrderNumber = purchaseOrderNumber.replace(/[^a-zA-Z0-9]/g, "_");
        document.title = sanitizedOrderNumber;
        this.ref = this.dialogService.open(ReportLookupComponent, {
          header: 'Purchase Order',
          width: '100%',
          data: {
            OrderNo: purchaseOrderNumber,
            ReportName: sanitizedOrderNumber,
            ReportPath: report.path
          }
        });
        this.ref.onClose.subscribe(() => {
          this.searchKey = '';
          document.title = 'Purchase Order List';
        });
      },
      error: (err) => {
        console.error('Report not found for form code:', formCode, err);
      }
    });
  }



  searchPO() {
    if (!this.searchKey) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please enter a search keyword' });
      return;
    }

    // this.loader = true;

    this.porderservice.autoSearchPO(this.searchKey).subscribe(
      (data: any) => {

        if (Array.isArray(data)) {
          this.result.purchaseOrder = data;

          this.pageRequest.pageSize = this.result.purchaseOrder.length;
          this.gridPagination = {
            ...this.gridPagination,
            totalRecords: this.result.purchaseOrder.length,
          };
          this.paginator = false;
        }
        else if (data && Array.isArray(data.purchaseOrder)) {
          this.result.purchaseOrder = data.purchaseOrder;

          this.pageRequest.pageSize = this.result.purchaseOrder.length;
          this.gridPagination = {
            ...this.gridPagination,
            totalRecords: this.result.purchaseOrder.length,
          };
          this.paginator = false;
        }
        else {
          this.result.purchaseOrder = [];
        }

        // this.loader = false;
      },
      (error) => {
        console.error('Search error:', error);
        // this.loader = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to fetch data' });
      }
    );
  }


  refreshData(): void {
    if (this.dt1) {
      this.dt1.first = 0;
      this.dt1.clear();
    }
    this.searchKey = '';
    this.pageRequest.pageIndex = 0;
    this.pageRequest.pageSize = 50;
    this.getPurchaOrder(this.pageRequest);
  }

  sendOrderEmail() {
    if (!this.selectedPOrder || this.selectedPOrder.length === 0) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please select at least one order' });
      return;
    }

    const authString = localStorage.getItem('auth');
    if (!authString) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Auth information is missing' });
      return;
    }

    const auth = JSON.parse(authString);
    if (!auth.tenant?.tenantCode) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Tenant Code is missing' });
      return;
    }

    const tenant = auth.tenant.tenantCode;
    const formCode = 'PurchaseOrder';

    this.loader = true;
    let processedCount = 0;
    let successCount = 0;
    let skippedCount = 0;
    const totalOrders = this.selectedPOrder.length;

    this.getUserDepartmentName().subscribe(departmentName => {
    this.selectedPOrder.forEach(order => {

      const selectedOrderId = order.purchaseOrderId;

      this.reportService.getReportName(formCode).pipe(

        switchMap((report: any) => {
          if (!report?.path) {
            throw new Error('REPORT_MISSING');
          }

          return this.porderservice.getPurchaseOrderById(selectedOrderId).pipe(
            map(orderData => ({
              orderData,
              reportPath: report.path
            }))
          );
        }),

        switchMap(({ orderData, reportPath }) => {

          if (!orderData?.vendor?.email) {
            throw new Error('EMAIL_MISSING');
          }

          return this.customerService.getCustomerById(orderData.shipToCustomerId).pipe(
            map(shipToCustomer => ({
              orderData,
              shipToCustomer: shipToCustomer || null,
              reportPath
            })),
            catchError(() =>
              of({ orderData, shipToCustomer: null, reportPath })
            )
          );
        }),

        switchMap(({ orderData, shipToCustomer, reportPath }) => {

          const shipToName = shipToCustomer?.customerName || 'N/A';

          return this.emailTemplateService.getTemplate('purchase-order-email-template').pipe(
            map(template => {

              if (!template) {
                throw new Error('TEMPLATE_MISSING');
              }

              const formatCurrency = (value: number) =>
                `₹${value.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;

              const templateData = {
                vendorName: orderData.vendor.vendorName,
                orderNumber: orderData.purchaseOrderNumber,
                requestedDate: new Date(orderData.requestedDate).toLocaleDateString(),
                shipToName,
                warehouseName: orderData.warehouse.warehouseName,
                orderTotal: formatCurrency(orderData.poTotal),
                cgstTotal: formatCurrency(orderData.cgstTotal),
                sgstTotal: formatCurrency(orderData.sgstTotal),
                igstTotal: formatCurrency(orderData.igstTotal),
                taxTotal: formatCurrency(orderData.taxTotal),
                currentYear: new Date().getFullYear(),
                companyName: this.companyInfo.companyName || '',
                companyEmail: this.companyInfo.companyEmail || '',
                companyPhone: this.companyInfo.companyPhone || '',
                companyWebsite: this.companyInfo.companyWebsite || ''
              };

              return {
                orderData,
                reportPath,
                emailBody: this.emailTemplateService.replacePlaceholders(template, templateData)
              };
            })
          );
        }),

        switchMap(({ orderData, reportPath, emailBody }) => {

          const emailData = {
            EmailToId: orderData.vendor.email,
            EmailToName: orderData.vendor.vendorName,
            EmailSubject: `Purchase Order ${orderData.purchaseOrderNumber} from ${this.companyInfo.companyName || 'our company'}`,
            EmailBody: emailBody,
            OrderNumber: orderData.purchaseOrderNumber,
            OrderType: 'PurchaseOrder',
            TenantId: tenant,
            ReportPath: reportPath,
            DepartmentName: departmentName 
          };

          return this.salesService.SendMail(emailData).pipe(
            map(() => orderData)
          );
        }),

        catchError(err => {
          processedCount++;
          console.error('Email failed:', err.message || err);

          if (processedCount === totalOrders) {
            this.loader = false;
          }

          return of(null);
        })

      ).subscribe({
        next: (orderData) => {

          if (orderData) {
            successCount++;
            this.createRecentInteractions(orderData, departmentName);
          }

          processedCount++;

          if (processedCount === totalOrders) {
            this.loader = false;

            if (successCount === 0) {
              this.messageService.add({
                severity: 'warn',
                summary: 'No Emails Sent',
                detail: 'Emails were not sent because required data (report / email / template) was missing.'
              });
            }
            else if (successCount < totalOrders) {
              this.messageService.add({
                severity: 'warn',
                summary: 'Partial Success',
                detail: `${successCount} email(s) sent. ${skippedCount} skipped due to validation issues.`
              });
            }
            else {
              this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: `Successfully sent ${successCount} email(s).`
              });
            }

            this.selectedPOrder = [];
          }
        }
      });

    });

  });

  }


  createRecentInteractions(data: any, departmentName: string = '') {
    const nowUTC = new Date();
    const istOffset = 5.5 * 60 * 60 * 1000;
    const istDate = new Date(nowUTC.getTime() + istOffset);

    const appKey = departmentName ? `dept.email.${departmentName}` : 'emailid';

    this.inventoryService.getSystemConfigByAppKey(appKey).subscribe({
      next: (config: any) => {
        const fromEmail = config?.data || 'default@example.com';

        const recentInteraction: RecentInteractions = {
          sendDate: istDate,
          type: 'Send Mail',
          from: fromEmail,
          to: data.vendor.email,
          subject: `Purchase Order ${data.purchaseOrderNumber}`,
          vendorNumber: data.vendorCode,
          refId: data.purchaseOrderId,
          description: "Purchase Order successfully placed",
          createdBy: localStorage.getItem('username') || '',
          isActive: true
        };

        this.salesService.createRecentInteractions(recentInteraction).subscribe({
          next: res => console.log('Recent interaction created:', res),
          error: err => console.error('Recent interaction error:', err)
        });
      },
      error: err => console.error('Recent interaction error:', err)
    });
  }

  getUserDepartmentName(): Observable<string> {
    const authString = localStorage.getItem('auth');
    if (!authString) return of('');

    const auth = JSON.parse(authString);
    const user = auth?.user;

    if (!user?.id) return of('');

    return this.administratorService.getUserById(user.id).pipe(
      switchMap((userData: any) => {
        const departmentId =
          userData?.departmentId;

        if (!departmentId) return of('');

        return this.porderservice.getDepartmentById(departmentId);
      }),
      map((departmentData: any) => {
        return departmentData?.departmentName;
      }),
      catchError(err => {
        console.error('Error fetching department name:', err);
        return of('');
      })
    );
  }

  getSystemConfigsData(): void {
    this.loader = true;
    const appKey = 'hide.columns_Products';

    this.inventoryService.getSystemConfigByAppKey(appKey).subscribe({
      next: (response: any) => {
        this.loader = false;
        if (response.appKeycode === appKey) {
          this.hide = response.data === 'N';
        }
      },
      error: error => {
        console.error('Error fetching System Config Data:', error);
        this.loader = false;
      }
    });
  }

  getCompanyDetails() {
    this.administratorService.getCompanyDetails().subscribe(
      (data: any) => {
        if (data && data.length > 0) {
          const company = data[0];
          this.companyInfo = {
            companyName: company.companyName,
            companyEmail: company.emailID1,
            companyPhone: company.mobile,
            companyWebsite: `https://${company.website?.replace(/^https?:\/\//, '')}`,
          };
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  placeholder: string = 'Search By ';
  private messages: string[] = ['Purchase Order', 'PO Date', 'Vendor Name', 'Unit Name', 'PO Total', 'Reqs Date', 'Status', 'Created By'];
  private messageIndex = 0;
  private charIndex = 0;


  searchEffect() {
    const base = 'Search By ';
    const typeNextChar = () => {
      if (this.charIndex <= this.messages[this.messageIndex].length) {
        this.placeholder = base + this.messages[this.messageIndex].substring(0, this.charIndex);
        this.charIndex++;
        setTimeout(typeNextChar, 150);
      } else {
        setTimeout(() => {
          this.messageIndex = (this.messageIndex + 1) % this.messages.length;
          this.charIndex = 0;
          typeNextChar();
        }, 1000);
      }
    };
    typeNextChar();
  }

  // statusColorMap: { [key: string]: string } = {
  //   'Pending Level 1 Approval': '#fa8202',
  //   // 'Pending Admin Approval': '#fa8202',     
  //   'Pending Admin Approval': '#6f42c1',
  //   'Rejected by POAdmin': '#dc3545',
  //   'Rejected': '#dc3545',
  //   'Approved': '#28a745',
  //   'Ready': '#007bff'
  // };

  statusColorMap: { [key: string]: string } = {
    'Pending Level 1 Approval': '#fa8202',
    'Pending Admin Approval': '#6f42c1',
    'Rejected by POAdmin': '#dc3545',
    'Rejected': '#dc3545',
    'Approved': '#28a745',
    'Ready': '#007bff',
    'Process': '#fd7e14',
    'Close': '#20c997',
    'Amended': '#17a2b8'
  };


}
